export const folderFormFields = {
	folderName: 'folderName',
} as const;
